import React from 'react';

import { useFormikContext } from 'formik';
import moment from 'moment';

import { showAlert } from 'components/shared/Alert/Alert';
import Button from 'components/shared/Buttons/Button';
import Popover from 'components/shared/Popovers/Popover/Popover';

import { checkUnsavedChanges } from '../lib/checkUnsavedChanges';

const activeClasses = 'animate-shine bg-gradient-to-r from-[#13b8ff] to-[#098cc1] !py-[5px]';

const UpdateAppointmentButton = ({
  buttonText = 'Update Appointment',
  handleAfterUpdate = () => {}
}) => {
  const { values, setFieldValue, handleSubmit, errors, initialValues } = useFormikContext();
  const { isUnsaved, updateOnlyThisAppointment, updateRecurrence } = checkUnsavedChanges(
    values,
    initialValues
  );

  const showErrorMissingProcedures = () => {
    if (errors?.procedures) {
      showAlert({ message: errors?.procedures, color: 'danger' });
    }
  };

  const isReschedule = !moment(values.starts_at).isSame(moment(initialValues.starts_at));

  const handleSubmitAppointment = (actionType) => {
    setFieldValue('actionType', actionType).then(handleSubmit);
  };

  const viewTypes = [
    {
      value: 'status',
      label: 'Update only this appointment',
      onClick: () => {
        showErrorMissingProcedures();
        handleSubmitAppointment('only');
        handleAfterUpdate();
      },
      icon: 'calendar-1-filled'
    },
    ...(values?.is_base_appointment
      ? [
          {
            value: 'confirmation',
            label: 'Update the entire series of appointments',
            onClick: () => {
              showErrorMissingProcedures();
              handleSubmitAppointment('following');
              handleAfterUpdate();
            },
            icon: 'calendar-filled'
          }
        ]
      : [
          {
            value: 'stage',
            label: 'Update this and all future appointments in the series',
            onClick: () => {
              showErrorMissingProcedures();
              handleSubmitAppointment('following');
              handleAfterUpdate();
            },
            icon: 'calendar-2-filled'
          }
        ])
  ];

  const handleUpdateAppointment = () => {
    showErrorMissingProcedures();
    const { isRecurrence } = values;
    if (isRecurrence && !updateRecurrence) {
      setFieldValue('actionType', 'only').then(() => {
        handleSubmit();
        handleAfterUpdate();
      });
      return;
    }

    handleSubmit();
    handleAfterUpdate();
  };

  if (updateOnlyThisAppointment) {
    return (
      <Button
        size="small"
        disabled={!isUnsaved}
        onClick={handleUpdateAppointment}
        text={isReschedule ? 'Update & Reschedule Appointment' : buttonText}
        className={isUnsaved && activeClasses}
      />
    );
  }

  return (
    <Popover
      id="appointment-statuses"
      className="rounded-md bg-white"
      panelClassName="max-h-[300px] xl:max-h-[500px] overflow-y-auto"
      text={isReschedule ? 'Update & Reschedule Appointment' : buttonText}
      buttonTheme="primary"
      isFixed
      isDropdown
      position="left"
      disabled={!isUnsaved}
      options={viewTypes}
      icon={false}
      textClassName="text-white"
      iconRightColor="white"
      buttonClassName={`bg-primary-500 bg-gradient-to-r from-[#13B8FF] to-[#098CC1] ${isUnsaved && 'animate-shine'}`}
    />
  );
};

export default UpdateAppointmentButton;
